module.exports = Promise.all([parcelRequire.load("l6xiM"), parcelRequire.load("h1Gb0"), parcelRequire.load("gm6vb")]).then(() => parcelRequire('5N0HA'));